// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #ddd;
  margin: 0;
  padding: 0;
}

.app {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #4648aa;
  color: #fff;
  padding: 0.7rem;
}

.logo {
  font-weight: bold;
  font-size: 1.2rem;
}

.nav-list {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-list li {
  margin-right: 1rem;
}

.nav-list li:last-child {
  margin-right: 0;
}

.nav-list li a {
  text-decoration: none;
  color: #fff;
  text-transform: none; /* Remove capitalization of header links */
}

.avatar {
  height: 50px;
  border-radius: 50%;
  padding-right: 0.7rem;
}

.main {
  display: flex;
  flex: 1 1;
}

/* <-------------------- Table */
table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 0.5rem;
  text-align: center;
  border: 1px solid #ccc;
}

th {
  font-weight: bold;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,oBAAoB,EAAE,0CAA0C;AAClE;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["body {\n  background-color: #ddd;\n  margin: 0;\n  padding: 0;\n}\n\n.app {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #4648aa;\n  color: #fff;\n  padding: 0.7rem;\n}\n\n.logo {\n  font-weight: bold;\n  font-size: 1.2rem;\n}\n\n.nav-list {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.nav-list li {\n  margin-right: 1rem;\n}\n\n.nav-list li:last-child {\n  margin-right: 0;\n}\n\n.nav-list li a {\n  text-decoration: none;\n  color: #fff;\n  text-transform: none; /* Remove capitalization of header links */\n}\n\n.avatar {\n  height: 50px;\n  border-radius: 50%;\n  padding-right: 0.7rem;\n}\n\n.main {\n  display: flex;\n  flex: 1;\n}\n\n/* <-------------------- Table */\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth,\ntd {\n  padding: 0.5rem;\n  text-align: center;\n  border: 1px solid #ccc;\n}\n\nth {\n  font-weight: bold;\n}\n\ntr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
